/** ID TOKEN is a decimal string, never a JavaScript monetary number. */
export function tokenDecimal(value: string): string {
  if (!/^[+-]?\d+(?:\.\d+)?$/.test(value)) throw new Error('token_amount_invalid');
  const negative = value.startsWith('-');
  const [whole, fraction = ''] = value.replace(/^[+-]/, '').split('.');
  const number = whole.replace(/^0+(?=\d)/, '') + (fraction.replace(/0+$/, '') ? '.' + fraction.replace(/0+$/, '') : '');
  return negative && number !== '0' ? '-' + number : number;
}

export function tokenSum(values: string[]): string {
  const normalized = values.map(tokenDecimal);
  const scale = Math.max(0, ...normalized.map(v => v.split('.')[1]?.length ?? 0));
  const sum = normalized.reduce((sum, value) => {
    const negative = value.startsWith('-');
    const [whole, fraction = ''] = value.replace(/^-/, '').split('.');
    const units = BigInt(whole + fraction.padEnd(scale, '0'));
    return sum + (negative ? -units : units);
  }, 0n);
  const digits = (sum < 0n ? -sum : sum).toString().padStart(scale + 1, '0');
  return tokenDecimal((sum < 0n ? '-' : '') + (scale ? digits.slice(0, -scale) + '.' + digits.slice(-scale) : digits));
}

export function tokenFormat(value: string): string {
  const [whole, fraction] = tokenDecimal(value).split('.');
  return whole.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + (fraction ? ',' + fraction : '');
}
